module.exports = __webpack_public_path__ + "static/media/icon11.d4679695.svg";